import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import axios from 'axios';
import { parseUrl, stringifyUrl } from 'query-string';
import { cart } from '@/theme/Cart';

@Component
export class CartMain extends ThemeComponent {
    @Prop({ default: 'cart-main' }) sectionId!: string;

    @Ref() updatingCart!: HTMLElement;
    @Ref() note!: HTMLElement[];

    init() {

        // Listen for cart item added
        document.addEventListener('cartChanged', (e: Event) => {

            // Handle item changes
            void this.updateItemsMarkup();

            // Add body class
            document.body.classList.add('cart-has-changed-since-load');
        });

        // Listen for changes to the cart note
        for (const [i, note] of this.note.entries()) {
            this.$listen(note, 'keyup', () => {
                const noteElement = note as HTMLTextAreaElement;
                cart.updateNote(noteElement.value).catch((event: unknown) => {
                    if (event instanceof Error) {
                        this.$log.error(event.message);
                    }
                });
            });
        }
    }

    public setLoading(loading: boolean = false) {
        if (loading) {
            this.updatingCart.classList.add('loading-spinner--active');
        } else {
            this.updatingCart.classList.remove('loading-spinner--active');
        }
    }

    /**
	 * Check if variant is in cart.
	 * @param variant - variant id.
	 */
    public checkCart(variant: number) {
        return (cart.items.filter((item) => ~~item.variantId === ~~variant)).length > 0;
    }

    public async updateItemsMarkup() {

        // Set cart main loading
        this.setLoading(true);

        // Build URL and get latest cart main markup
        const { url, query } = parseUrl(window.location.href, { decode: false });
        const newUrl = stringifyUrl({
            url: url,
            query: {
                ...query,
                sections: `${this.sectionId}`,
            }
        }, { arrayFormat: 'none', encode: false });
        const res = await axios.get(newUrl);

        // Prepare correct markup
        const newCartMain = document.createElement('div');
        newCartMain.innerHTML = res.data[`${this.sectionId}`];
        const newCartMainContainer = newCartMain.querySelector('.cart-main__container');
        const currentCartMainContainer = this.querySelector('.cart-main__container');
        if (newCartMainContainer && currentCartMainContainer) {
            currentCartMainContainer.outerHTML = newCartMainContainer.outerHTML;
        }

        // Set cart main loading
        this.setLoading(false);
    }
}
